import { StatusSort, useExpandedSortState } from '../../state/sorting.state';

import Button from '@ingka/button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { SortLabel } from '../table/SortLabel';
import sortIcon from '@ingka/ssr-icon/paths/menu';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/core/theme';
import { tokens } from '../../../../shared/styles/core/tokens';

const StyledMenuItemDiv = styled.div`
   display: flex;
   align-items: center;
`;

const StyledMenuItem = styled(MenuItem)`
   font-size: ${tokens.font.size.sm};
`;

export const StatusSortMenu = () => {
   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
   const open = Boolean(anchorEl);

   const { sorting, setSorting, statusSort, setStatusSort } = useExpandedSortState();

   const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
   };
   const handleClose = () => {
      setAnchorEl(null);
   };

   const isActiveSortedDesc = sorting[0]?.id === 'select' && statusSort === StatusSort.active ? sorting[0].desc : undefined;
   const isLockedSortedDesc = sorting[0]?.id === 'select' && statusSort === StatusSort.locked ? sorting[0].desc : undefined;

   const onToggleSort = (newStatusSort: StatusSort) => {
      if (newStatusSort !== statusSort) {
         setSorting([{ id: 'select', desc: false }]);
         setStatusSort(newStatusSort);
      } else {
         if (sorting[0]?.id === 'select' && sorting[0]?.desc) {
            setStatusSort(StatusSort.none);
            setSorting([]);
         } else {
            setSorting([{ id: 'select', desc: true }]);
         }
      }
   };

   return (
      <div>
         <Button
            type="tertiary"
            style={{ color: sorting[0]?.id === 'select' ? theme.colors.text.primary : theme.colors.bg.tertiary }}
            small={true}
            ssrIcon={sortIcon}
            iconOnly={true}
            onClick={handleClick}
         />
         <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            sx={{ borderRadius: '0px' }}
            elevation={4}
            MenuListProps={{
               'aria-labelledby': 'basic-button',
            }}
         >
            <StyledMenuItem onClick={() => onToggleSort(StatusSort.active)}>
               <StyledMenuItemDiv>
                  <span>Active</span> <SortLabel isSortedDesc={isActiveSortedDesc} />
               </StyledMenuItemDiv>
            </StyledMenuItem>
            <StyledMenuItem onClick={() => onToggleSort(StatusSort.locked)}>
               <StyledMenuItemDiv>
                  <span>Locked</span> <SortLabel isSortedDesc={isLockedSortedDesc} />
               </StyledMenuItemDiv>
            </StyledMenuItem>
         </Menu>
      </div>
   );
};
